// Nav entry of Shared (shell/nav.ts collects every routes/*.nav.ts; `order` places it in the rail, the tabs and Lisää).
import { defineNav } from '../shell/nav-entry';

export const nav = defineNav({ id: 'shared', path: '/shared', icon: 'shared', group: 'together', phone: 'more', order: 1000, load: () => import('./Shared') });
